<template>
  <v-col cols="3" id="notification-container">
    <notification v-for="notification in notifications" :key="notification.id" :notification="notification" />
  </v-col>
</template>

<script lang="ts">
import Vue from 'vue';
import Notification from '@/components/notifications/notification.vue';
import { Notification as NotificationModel, notificationCenter } from '@/modules/notification-center';

export default Vue.extend({
  components: {
    Notification
  },
  computed: {
    notifications(): NotificationModel[] {
      return [...notificationCenter.stack].reverse();
    }
  }
});
</script>

<style lang="scss" scoped>
#notification-container {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 2;
}
</style>
